import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const SeDetailsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-shop', title: 'Shops & Establishment Details', subtitle: 'Fetch SE registration details by ID + state code' }}
        fields={[
            { name: 'id_number', label: 'SE ID Number', icon: 'pi-hashtag', placeholder: 'SE registration ID', maxLength: 30, mono: true },
            { name: 'state_code', label: 'State Code', icon: 'pi-map-marker', placeholder: 'e.g. MH', maxLength: 5, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              colClass: 'col-12 md:col-4 lg:col-3' },
        ]}
        endpoint={{
            path: '/surepass/se/details',
            bodyMapper: (v, sid) => ({ id_number: v.id_number.trim(), state_code: v.state_code, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="se-details"
        submitLabel="Fetch SE Details"
        successSummary="SE details fetched"
        errorSummary="SE details failed"
        confirmHeader="Confirm SE details fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Shops & Establishment Details', icon: 'pi-shop' }}
    />
);

export default SeDetailsInputComponent;
